(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyvra-02-so-einfach"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lyvra-warmth-video')) {
  customElements.define('lyvra-warmth-video', class extends HTMLElement {
    connectedCallback() {
      this.cleanup = new AbortController();
      this.media = this.querySelector('[data-media]');
      this.button = this.querySelector('[data-play]');
      this.status = this.querySelector('[data-status]');
      if (!this.media || !this.button) return;
      try { this.sources = JSON.parse(this.media.dataset.sources); } catch (_) { return; }
      const signal = this.cleanup.signal;
      this.button.addEventListener('click', () => this.start(false), { signal });
      const connection = navigator.connection;
      this.autoAllowed = this.dataset.autoplay === 'true'
        && !matchMedia('(prefers-reduced-motion: reduce)').matches
        && !(connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType)));
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          if (!this.inView) {
            if (this.video) this.video.pause();
          } else if (this.autoAllowed && !this.autoStopped && !document.hidden) {
            this.start(true);
          }
        }, { threshold: 0.35 });
        this.observer.observe(this.media);
      }
      document.addEventListener('visibilitychange', () => {
        if (document.hidden && this.video) this.video.pause();
      }, { signal });
    }
    start(automatic) {
      if (!automatic) { this.autoStopped = true; this.autoAllowed = false; }
      if (!this.video) {
        const mobile = matchMedia('(max-width: 749px)').matches;
        const limit = mobile ? 480 : 720;
        const sources = this.sources.filter(s => s.format === 'mp4' && s.url)
          .sort((a, b) => a.width - b.width);
        const source = sources.filter(s => s.width <= limit).pop() || sources[0];
        if (!source) return;
        const video = document.createElement('video');
        video.className = 'lvw02__video';
        video.controls = true;
        video.playsInline = true;
        video.preload = 'none';
        video.muted = true;
        video.loop = automatic;
        video.setAttribute('aria-label', this.media.dataset.videoLabel);
        const poster = this.media.querySelector('img');
        if (poster) video.poster = poster.currentSrc || poster.src;
        video.src = source.url;
        const signal = this.cleanup.signal;
        video.addEventListener('error', () => {
          this.autoStopped = true;
          this.status.textContent = 'Das Video konnte nicht geladen werden. Bitte erneut versuchen.';
          video.remove();
          this.video = null;
          this.button.hidden = false;
        }, { signal });
        video.addEventListener('pause', () => {
          if (this.inView && !document.hidden) this.autoStopped = true;
        }, { signal });
        this.video = video;
        this.media.append(video);
        this.button.hidden = true;
        this.status.textContent = '';
      }
      this.video.play().catch(() => { this.autoStopped = true; });
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup.abort();
      if (this.observer) this.observer.disconnect();
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.video.remove();
        this.video = null;
      }
      if (this.button) this.button.hidden = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyvra-03-ueberall-warm"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lyvra-everywhere-videos')) {
  customElements.define('lyvra-everywhere-videos', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.cleanup = new AbortController();
      const signal = this.cleanup.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-play]');
        if (button) this.start(button);
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.querySelectorAll('video').forEach(video => video.pause());
      }, { signal });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const video = entry.target.querySelector('video');
            if (video && entry.intersectionRatio < .25) video.pause();
          });
        }, { threshold: [0, .25] });
        this.querySelectorAll('[data-media]').forEach(media => this.observer.observe(media));
      }
    }
    start(button) {
      const media = button.closest('[data-media]');
      if (media.querySelector('video')) return;
      let sources;
      try { sources = JSON.parse(media.dataset.sources); } catch (_) { return; }
      if (!Array.isArray(sources)) return;
      sources = sources.filter(source => source.url && source.format === 'mp4')
        .sort((a, b) => a.width - b.width);
      const limit = Math.min(720, Math.max(360, media.clientWidth * Math.min(window.devicePixelRatio || 1, 2)));
      const source = sources.find(source => source.width >= limit) || sources[sources.length - 1];
      if (!source) return;
      this.querySelectorAll('video').forEach(video => video.pause());
      const video = document.createElement('video');
      const status = media.querySelector('[data-status]');
      video.className = 'lvw03__video';
      video.controls = true;
      video.playsInline = true;
      video.preload = 'none';
      video.muted = true;
      video.setAttribute('aria-label', media.dataset.label);
      const poster = media.querySelector('img');
      if (poster) video.poster = poster.currentSrc || poster.src;
      video.src = source.url;
      const signal = this.cleanup.signal;
      const restore = message => {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.remove();
        button.hidden = false;
        status.textContent = message;
      };
      video.addEventListener('error', () => restore('Das Video konnte nicht geladen werden. Bitte erneut versuchen.'), { signal });
      video.addEventListener('play', () => {
        this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      }, { signal });
      status.textContent = '';
      button.hidden = true;
      media.append(video);
      video.focus({ preventScroll: true });
      video.play().catch(() => {
        if (video.isConnected) restore('Bitte erneut auf das Video tippen.');
      });
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup.abort();
      this.cleanup = null;
      if (this.observer) this.observer.disconnect();
      this.querySelectorAll('video').forEach(video => {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.remove();
      });
      this.querySelectorAll('[data-play]').forEach(button => { button.hidden = false; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyvra-04-mehr-als-decke"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lyvra-purchase-comparison')) {
  customElements.define('lyvra-purchase-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.cleanup = new AbortController();
      this.link = this.querySelector('[data-purchase-scroll]');
      if (!this.link) return;
      const target = this.findTarget();
      if (target && target.id) this.link.setAttribute('href', '#' + encodeURIComponent(target.id));
      this.link.addEventListener('click', event => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const purchase = this.findTarget();
        const offset = Number(this.dataset.offset) || 0;
        const top = purchase ? Math.max(0, purchase.getBoundingClientRect().top + window.scrollY - offset) : 0;
        window.scrollTo({ top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal: this.cleanup.signal });
    }
    findTarget() {
      if (this.dataset.target.trim()) {
        try {
          const selected = document.querySelector(this.dataset.target.trim());
          if (selected) return selected;
        } catch (_) { /* Fall back to the product form if the selector is invalid. */ }
      }
      const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
      const form = forms.find(candidate =>
        candidate.getClientRects().length &&
        !candidate.closest('quick-add-modal, quick-add, cart-drawer, [role="dialog"], .shopify-section-header, sticky-add-to-cart, .sticky-add-to-cart') &&
        candidate.querySelector('[name="id"]')
      );
      if (!form) return null;
      return form.closest('product-info, .product__info-container, .product__info-wrapper, [data-product-info]') || form;
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup.abort();
      this.cleanup = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyvra-06-customer-reviews-fixed"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lyvra-comb-reviews')) {
  customElements.define('lyvra-comb-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.prev || !this.next) return;
      this.cleanup = new AbortController();
      const signal = this.cleanup.signal;
      this.querySelector('[data-nav]').hidden = false;
      this.prev.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, { signal, passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.update(), { signal });
      }
      this.update();
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= maximum - 1;
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup.abort();
      this.cleanup = null;
      if (this.observer) this.observer.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyvra-06-customer-reviews1"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lyvra-comb-reviews')) {
  customElements.define('lyvra-comb-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.prev || !this.next) return;
      this.cleanup = new AbortController();
      const signal = this.cleanup.signal;
      this.querySelector('[data-nav]').hidden = false;
      this.prev.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, { signal, passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.update(), { signal });
      }
      this.update();
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= maximum - 1;
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup.abort();
      this.cleanup = null;
      if (this.observer) this.observer.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyvra-06-kommentare"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lyvra-comment-strip')) {
  customElements.define('lyvra-comment-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.cleanup = new AbortController();
      const signal = this.cleanup.signal;
      this.track = this.querySelector('[data-track]');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.prev || !this.next) return;
      this.querySelector('[data-nav]').hidden = false;
      this.prev.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
      }, { signal, passive: true });
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', () => this.update(), { signal });
      }
      this.update();
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup.abort();
      this.cleanup = null;
      if (this.observer) this.observer.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lyvra-aktionsleiste"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lyvra-promo-bar')) {
    customElements.define('lyvra-promo-bar', class extends HTMLElement {
      connectedCallback() {
        const timer = this.querySelector('[role="timer"]');
        const storageKey = 'lyvra-early-black-friday-start-v1';
        const cycleSeconds = 17 * 3600 + 1;
        const now = Date.now();
        let start = now;

        try {
          const stored = Number(localStorage.getItem(storageKey));
          if (Number.isFinite(stored) && stored > 0 && stored <= now) {
            start = stored;
          } else {
            localStorage.setItem(storageKey, String(start));
          }
        } catch {
          start = this.previewStart || now;
          this.previewStart = start;
        }

        const update = () => {
          const elapsed = Math.floor(Math.max(0, Date.now() - start) / 1000);
          const remaining = cycleSeconds - 1 - elapsed % cycleSeconds;
          const display = [
            Math.floor(remaining / 3600),
            Math.floor(remaining / 60) % 60,
            remaining % 60
          ].map(value => String(value).padStart(2, '0')).join(':');
          if (timer.textContent !== display) timer.textContent = display;
        };

        update();
        const title = this.querySelector('.lyvra-promo__campaign');
        if (title && 'ResizeObserver' in window) {
          const text = title.firstElementChild;
          this.titleObserver = new ResizeObserver(() => {
            const overflow = text.offsetWidth - title.clientWidth;
            title.style.setProperty('--lyvra-title-offset', -overflow + 'px');
            title.style.setProperty('--lyvra-title-duration', Math.max(4, overflow / 20 + 2) + 's');
            title.toggleAttribute('data-scroll', overflow > 0);
          });
          this.titleObserver.observe(title);
          this.titleObserver.observe(text);
        }
        this.interval = setInterval(update, 200);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
        this.titleObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proven-result"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lyvra-result-compare')) {
    customElements.define('lyvra-result-compare', class extends HTMLElement {
      connectedCallback() {
        const range = this.querySelector('input');
        const visual = this.querySelector('.pr-visual');
        if (!range || !visual || this.controller) return;

        this.controller = new AbortController();
        const update = () => visual.style.setProperty('--pr-split', range.value + '%');
        range.addEventListener('input', update, { signal: this.controller.signal });
        range.disabled = false;
        update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
